import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const addPhoneNumberApi = async (payload = {}, authHeaders = {}) => {
  try {
    const body = {
      operation: 'ADD_PHONE_NUMBER',
      payload: {
        phoneNumber: payload.phoneNumber
      }
    };

    const res = await apiCallPost(apiPaths.userProfile, body, authHeaders);

    if (res && (res.phoneNumber || res.message)) {
      return {
        data: res,
        status: true,
        msg: res.message || 'OTP sent to WhatsApp'
      };
    }

    return {
      data: res || {},
      status: false,
      errMsg: res?.message || 'Failed to send OTP'
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message || 'Failed to send OTP'
    };
  }
};

export const verifyPhoneNumberApi = async (payload = {}, authHeaders = {}) => {
  try {
    const body = {
      operation: 'VERIFY_PHONE_NUMBER',
      payload: {
        otp: payload.otp
      }
    };

    const res = await apiCallPost(apiPaths.userProfile, body, authHeaders);

    if (res && (res.phoneNumber || res.message)) {
      return {
        data: res,
        status: true,
        msg: res.message || 'Phone number verified successfully'
      };
    }

    return {
      data: res || {},
      status: false,
      errMsg: res?.message || 'Failed to verify phone number'
    };
  } catch (err) {
    return {
      status: false,
      errMsg: err.message || 'Failed to verify phone number'
    };
  }
};